<template>
  <div class="dash-upload-more" :class="[size]" :types='types'>
      <ul class="v-upload-list">
        <li v-for="(item, index) in imgUrl" :key="index" class="v-upload-list__item">
          <div :class="types == 'piiic' ? 'piiic' : 'v-upload-list__item-img' " v-loading="imgLoading[index]">
            <el-image v-if="media === 'picture'" :src="item" :fit="fit"></el-image>
            <video
              v-if="media === 'video'"
              :src="item"
              class="picture"
              id="video"
              controls></video>
            <!-- <video controls="controls" v-if="media === 'video'" class="picture" id="video">
              <source :src="item" type="video/mp4">
              Your browser does not support the video tag.
            </video> -->
          </div>
          <div class="v-upload-list__item-actions">
            <span
                class="el-upload-list__item-todo"
                :class="{'disabled': loadingStatus}"
                @click="triggerUpload(index)">{{ $t('Upload again') }}</span>
            <span
                class="el-upload-list__item-todo"
                :class="{'disabled': loadingStatus}"
                @click="del(index)">{{ $t('del') }}</span>
          </div>
        </li> 
        <el-upload
          class="v-upload-more"
          action=""
          :ref="uploadAddName"
          v-loading="loadingStatus"
          v-show="fileList.length < limit && uploadBtn"
          list-type="picture-card"
          :multiple="true"
          :limit="limit"
          :class="{'picture-uploader-disabled': disabled}"
          :disabled="disabled"
          :file-list="fileList"
          :show-file-list="false"
          :accept="fileType"
          :http-request="uploadPicture"
          :before-upload="beforeUpload"
          :on-exceed="onExceed"
          :on-change="onChange">
            <i slot="default" class="el-icon-plus"></i></el-upload> 
      </ul>
      <el-upload
        class="v-upload-more"
        action=""
        :ref="uploadAddName"
        v-loading="loadingStatus"
        v-show="fileList.length < limit && uploadBtn"
        list-type="picture-card"
        :multiple="true"
        :limit="limit"
        :class="{ 'picture-uploader-disabled': disabled }"
        :disabled="disabled"
        :file-list="fileList"
        :show-file-list="false"
        :accept="fileType"
        :http-request="uploadPicture"
        :before-upload="beforeUpload"
        :on-exceed="onExceed"
        :on-change="onChange"
      >
        <i slot="default" class="el-icon-plus"></i
      ></el-upload>
    <el-upload
      style="display: none"
      :ref="uploaderName"
      action=""
      :file-list="cFileList"
      :accept="fileType"
      :http-request="
        file => {
          uploadPicture(file, cIndex)
        }
      "
      :before-upload="
        file => {
          beforeUpload(file, cIndex)
        }
      "
    ></el-upload>
  </div>
</template>
<script>
import { 
  // uploadImageByBaseStr,
  uploadOssByStream
} from '@/api/index'

export default {
  name: 'dash-upload-more',
  data() {
    return {
      loading: false,
      imgUrl: [],
      fileType: '',
      imgLoading: [],
      fileList: [],
      cIndex: 0,
      cFileList: [],
      uploadAddName: 'upload_' + parseInt(Math.random() * 100000000).toString() + '_' + Date.now(),
      uploaderName: 'uploader_' + parseInt(Math.random() * 100000000).toString() + '_' + Date.now()
    }
  },

  props: {
    // 上传文件的类型
    accept: {
      default: 'image/jpg,image/jpeg,image/png,image/gif',
      type: String
    },
    // 上传媒体类型： picture / video
    media: {
      type: String,
      default: 'picture'
    },
    // 功能文字位置： bottom / right
    layout: {
      type: String,
      default: 'bottom'
    },
    //尺寸： small / medium / large / square
    size: {
      type: String,
      default: 'small'
    },
    // 已上传文件路径
    mediaUrl: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 是否不可编辑
    disabled: {
      type: Boolean,
      default: false
    },
    uploadBtn: {
      type: Boolean,
      default: true
    },
    limit: {
      type: Number,
      default: 9
    },
    types: {
      type: String,
      default: ''
    },
    fit: {
      type: String,
      default: 'contain'
    }
  },

  watch: {
    mediaUrl: function() {
      this.init()
    }
  },

  computed: {
    loadingStatus() {
      let list = this.imgLoading.filter(item => {
        return item === true
      })
      return list.length == 0 ? false : true
    }
  },

  mounted() {
    this.fileType = this.accept
    this.init()
  },

  methods: {
    init() {
      this.imgUrl = this.mediaUrl || []
      if (typeof this.imgUrl == 'string') {
        this.imgUrl = this.imgUrl.split(',')
      }
      if (this.media === 'video') {
        this.fileType = '.mp4,.avi,.wmv,.mpg,.mpeg,.3gp,.mov,.flv,.rmvb,.vob,.mkv'
      }
      let list = []
      this.imgUrl.forEach(item => {
        list.push({ url: item })
      })
      this.fileList = list
    },
    uploadPicture(req, index) {
      console.log(index)
      const reader = new FileReader()
      const iIndex = index === undefined ? this.selectLen - 1 : index
      reader.readAsDataURL(req.file)
      reader.onload = () => {
        // 这个地方，可以得到 选中了文件的数据量
        // 获取文件名
        function getType(file) {
          var filename = file
          var index1 = filename.lastIndexOf('.')
          var index2 = filename.length
          var type = filename.substring(index1, index2)
          var name = parseInt(Math.random() * 100000000).toString()
          return [name, type]
        }

        // 文件上传失败的方法
        function rError() {
          console.log(this.imgUrl)
          this.imgUrl[iIndex] = ''
        }

        let [name, type] = getType(req.file['name'])
        name = name.replace(/,/g, '')
        let params = {
          bucketName: 'ef-imaster-file',
          objectName: 'mianliao/' + name + '_' + new Date().valueOf() + type,
          baseStr: reader.result.split(',')[1],
          bizType: 'IMAGEFILE'
        }

        // 视频参数
        let config = {}
        if (this.media === 'video') {
          params.bucketName = 'ef-imaster-file'
          config.onUploadProgress = progressEvent => {
            let percent = ((progressEvent.loaded / progressEvent.total) * 100) | 0
            //调用onProgress方法来显示进度条，需要传递个对象 percent为进度值
            console.log(percent, progressEvent)
          }
        }

        var formData = new FormData()
        // var objectName = req.file['name'].slice(0,req.file['name'].lastIndexOf('.'))+ parseInt(Math.random() * 100000000).toString()+req.file['name'].slice(req.file['name'].lastIndexOf('.'))
        // var dataName = req.file['name']
        var objectName = params.objectName
        formData.append('bucketName','ef-imaster-file')
        formData.append('objectName',objectName)
        formData.append('file',req.file)
        formData.append('bizType','IMAGEFILE')
        // var fileType = req.file['type']
        
        uploadOssByStream(formData, config)
          .then(res => {
            if (!res.data.data) {
              rError()
              return
            }
            this.$set(this.imgUrl, iIndex, res.data.data)
            this.$emit('update:mediaUrl', this.imgUrl)
          })
          .catch(() => {
            rError()
          })
          .finally(() => {
            this.changeLoading(iIndex, false)
          })
      }
    },

    changeLoading(index, status) {
      this.loading = status
      if (this.curSelectNum != 0 && index === undefined) {
        this.$set(this.imgLoading, this.selectLen - 1, status)
      } else if (index || index === 0) {
        this.$set(this.imgLoading, index, status)
      }
    },

    beforeUpload(file, index) {
      this.changeLoading(index, true)
      if (this.media === 'picture') {
        const isLt2M = file.size / 1024 / 1024 < 2
        if (!isLt2M) {
          this.changeLoading(index, false)
          this.$message.error(this.$t('Uploaded image can not greater than 1Mb'))
        }
        return isLt2M
      }

      if (this.media === 'video') {
        const isLt = file.size / 1024 / 1024 < 100
        if (!isLt) {
          this.changeLoading(index, false)
          this.$message.error(this.$t('Uploaded video can not greater than 100Mb'))
          this.del(0)
        }
        return isLt
      }
    },

    onChange(file, fileList) {
      if (this.media === 'picture') {
        const isLt2M = file.size / 1024 / 1024 < 2
        if (isLt2M) {
          this.imgUrl.push(file.name)
        }
      } else {
        this.imgUrl.push(file.name)
      }
      console.log(fileList)
      this.fileList = fileList
      this.selectLen = fileList.length
    },

    onExceed() {
      this.$message.error(this.$t('uploadTips3') + this.limit)
    },

    triggerUpload(index) {
      this.cIndex = index
      this.$refs[this.uploaderName].$refs['upload-inner'].$refs['input'].click()
    },

    uploadAdd() {
      this.$refs[this.uploadAddName].$refs['upload-inner'].$refs['input'].click()
    },

    del(index) {
      this.imgUrl.splice(index, 1)
      this.fileList.splice(index, 1)
      this.cFileList = []
      this.$emit('update:mediaUrl', this.imgUrl)
    }
  }
}
</script>
<style lang="stylus">
.large {
  .v-upload-list .v-upload-list__item-img {
    width: 1000px;
    height: 560px;
    border: none;
  }
}
.v-upload-list {
    display: inline-block;
    vertical-align: top;

    .v-upload-list__item {
      display: inline-block;
      margin: 0 16px 16px 0;
      vertical-align: top;
    }
    .v-upload-list__item-img {
      width: 198px;
      height: 198px;
      border: 1px solid $border-color-e5;
      overflow: hidden;

      .el-image,
      .picture {
        width: 100%;
        height: 100%;
      }
    }

    .piiic {
      width: 885px;
      height: 1328px;
      border: 1px solid $border-color-e5;
      overflow: hidden;

      .el-image,
      .picture {
        width: 100%;
        height: 100%;
      }
      
    }

    .v-upload-list__item-actions {
      margin-top: 8px;
      line-height: 20px;
      font-size: 13px;
      color: $color-main;
      text-align: right;

      .el-upload-list__item-todo {
        cursor pointer
        & + .el-upload-list__item-todo{
          margin-left: 12px;
        }
      }
    }
}

.dash-upload-more {
  line-height: 0;
  .v-upload-more {
    display: inline-block;
  }

  .el-upload--picture-card {
      border-radius: 0px;

      i {
        font-size: 56px;
        vertical-align: -8px;
      }

      &:hover {
        i {
          color: $color-main;
        }
      }
    }

  &.small {
    .el-upload--picture-card {
      width: 198px;
      height: 198px;
      line-height 198px;
    }
  }

  &.long {
    .el-upload--picture-card {
      width: 300px;
      height: 140px;
      line-height 140px;
    }
  }

  &.long2 {
    .el-upload--picture-card {
      width: 401px;
      height: 187px;
      line-height 187px;
    }
  }
}

.long {
  .v-upload-list {
    .v-upload-list__item-img {
       width: 300px;
       height: 140px;
    }
  }
}

.long2 {
  .v-upload-list {
    .v-upload-list__item-img {
       width: 401px;
       height: 187px;
    }
  }
}
</style>
